interface AppConfig {
  instrumentationKey?: string;
}

export const appConfig: AppConfig = {
  instrumentationKey:
    window.APPINSIGHTS_INSTRUMENTATIONKEY ||
    process.env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY,
};
